// What a bot is doing right now, in words, from its live run events.
export const RUNNING = new Set(['queued', 'running']);
// Tools that work on the project's computer: the computer view comes up when one starts.
export const WORKSPACE_TOOLS = new Set(['computer', 'shell', 'read_file', 'write_file', 'attachment_to_computer',
  'browser_read', 'browser_act', 'browser_view', 'browser_screenshot']);

const TOOLS = ['get_task', 'list_tasks', 'list_projects', 'list_task_comments', 'create_task', 'update_task',
  'add_task_comment', 'delete_task', 'memory', 'computer', 'shell', 'read_file', 'write_file', 'web_fetch', 'skill_view', 'skill_propose', 'rule_propose', 'request_secret', 'search_chats', 'read_chat', 'attachment_to_computer', 'create_document',
  'update_document', 'read_document', 'list_documents', 'web_search',
  'hand_over_task', 'browser_read', 'browser_act', 'browser_view', 'browser_screenshot'];

// The computers running when the plan runs all it may at once (the server's computers_busy):
// named, so the person knows which one to put to sleep.
export const busyComputers = (t, { cap, running }) => ({
  count: cap, projects: (running || []).map((r) => (r.home ? t('common.no_project') : r.name)).join(', '),
});

export const activityLabel = (t, live) => {
  if (live?.computerWait) return t('bots.chat.waiting_computer', busyComputers(t, live.computerWait));
  if (live?.tool) return t(TOOLS.includes(live.tool) ? `bots.chat.tools.${live.tool}` : 'bots.chat.tools.default');
  return t('bots.chat.thinking');
};
